import { PageHeader } from '@ver-uds/react';
import ReactGA from 'react-ga4';
import React, { ReactNode, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Feature from '../../constants/Feature';
import Container from './Container/Container';

interface Props {
  title: string;
  header: string;
  content: Feature;
  children: ReactNode;
  showTraining: boolean;
}

const PageContainer = ({ title, header, content, children, showTraining }: Props): JSX.Element => {
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      pageTitle: title,
    });
  }, [title]);
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageHeader>{header}</PageHeader>
      <Container content={content} showTraining={showTraining}>
        {children}
      </Container>
    </>
  );
};

export default PageContainer;
